import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getFuelStations(companyId, cashedPayload) {
  return dataTransferWrap(
    ModulesMap.FUEL_STATIONS,dtConfig[ModulesMap.FUEL_STATIONS].getFuelStations,
    {
      urlParams: {
        companyId,
      },
    },
    cashedPayload
  )
}

function getFuelStation(companyId, fuelStationId) {
  return dataTransferWrap(ModulesMap.FUEL_STATIONS,dtConfig[ModulesMap.FUEL_STATIONS].getFuelStation, {
    urlParams: {
      companyId,
      fuelStationId,
    },
  })
}

function getFuelStationPreview(companyId, fuelStationId) {
  return dataTransferWrap(ModulesMap.FUEL_STATIONS,dtConfig[ModulesMap.FUEL_STATIONS].getFuelStationPreview, {
    urlParams: {
      companyId,
      fuelStationId,
    },
  })
}

function getFuelStationPopup(companyId, fuelStationId) {
  return dataTransferWrap(ModulesMap.FUEL_STATIONS,dtConfig[ModulesMap.FUEL_STATIONS].getFuelStationPopup, {
    urlParams: {
      companyId,
      fuelStationId,
    },
  })
}

function postFuelStation(companyId, data) {
  return dataTransferWrap(ModulesMap.FUEL_STATIONS,dtConfig[ModulesMap.FUEL_STATIONS].postFuelStation, {
    urlParams: {
      companyId,
    },
    ...data,
  })
}

function patchFuelStation(companyId, fuelStationId, data) {
  return dataTransferWrap(ModulesMap.FUEL_STATIONS,dtConfig[ModulesMap.FUEL_STATIONS].patchFuelStation, {
    urlParams: {
      companyId,
      fuelStationId,
    },
    ...data,
  })
}

function putFuelStation(companyId, fuelStationId, data) {
  return dataTransferWrap(ModulesMap.FUEL_STATIONS,dtConfig[ModulesMap.FUEL_STATIONS].putFuelStation, {
    urlParams: {
      companyId,
      fuelStationId,
    },
    ...data,
  })
}

function deleteFuelStation(companyId, fuelStationId) {
  return dataTransferWrap(ModulesMap.FUEL_STATIONS,dtConfig[ModulesMap.FUEL_STATIONS].deleteFuelStation, {
    urlParams: {
      companyId,
      fuelStationId,
    },
  })
}

export default {
  getFuelStations,
  getFuelStation,
  getFuelStationPreview,
  getFuelStationPopup,
  postFuelStation,
  patchFuelStation,
  putFuelStation,
  deleteFuelStation
}